import Contact from '@/services/contact'

const resendInvite = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Contact.resendInvite(id).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

const createContact = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Contact.create(payload).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  resendInvite,
  createContact
}



// WEBPACK FOOTER //
// ./src/features/contacts/store/actions.js